module.exports = __webpack_public_path__ + "static/media/1001567DO.743f8d97.jpg";